export const MAX_LABELS = 3

export const normalizeLabels = (value: unknown, maxLabels = MAX_LABELS): string[] => {
  const rawLabels = Array.isArray(value) ? value : [value]
  const normalizedLabels: string[] = []
  const seen = new Set<string>()

  for (const label of rawLabels) {
    const normalizedLabel = String(label ?? '').trim()
    const normalizedKey = normalizedLabel.toLowerCase()
    if (!normalizedLabel || seen.has(normalizedKey)) continue
    normalizedLabels.push(normalizedLabel)
    seen.add(normalizedKey)
    if (normalizedLabels.length === maxLabels) break
  }
  return normalizedLabels
}
